export const CommonPanel = {
  "LocalComputer": "Local Computer",
  "SaveAs": "Save As",
  "Url": "Add WebPage",
  "FromClipboard": "From Clipboard",
  "OneDrive": "OneDrive",
  "Box": "Box",
  "DropBox": "Dropbox",
  "GoogleDrive": "Google Drive",
  "iManage": "iManage 10",
  "DropFileHere": "Drop File Here",
  "ClickOrDropFileHere": "Click or drag the document",
  "ClickToUpload": "Click to Upload",
  "ChooseFile": "Choose Files",
  "PreviousStep": "Previous Step",
  "EnterThePdfFileUrl": "Input the URL of your file",
  "Cancel": "Cancel",
  "Open": "Open",
  "InputValidUrl": "Please input a valid URL",
  "SaveToLocalComputer": "Save to Local Computer",
  "SaveAsToLocalComputer": "Save more formats to the local computer",
  "Download": "Download",
  "Documents": "Cloud Documents",
  "UploadToStorage": "Upload local document to Cloud Documents by default.<br>You can disable the option in <a>Preferences</a>.",
  "OpenLocalTabTitle": "Open file",
  "SaveLocalTabTitle": "Save to",
  "OpenOtherTabTitle": "Import from",
  "SaveOtherTabTitle": "Save to other",
}